import React, { useState, useEffect } from "react";

// Formats a numeric string with Chilean thousands separators (1.000.000)
const formatCL = (raw) => {
  if (raw === null || raw === undefined || raw === "") return "";
  const digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";
  return new Intl.NumberFormat("es-CL").format(parseInt(digits, 10));
};

const NumberInput = (props) => {
  const { id, required, placeholder, label, onChange, value } = props;
  const [display, setDisplay] = useState(formatCL(value));

  useEffect(() => {
    setDisplay(formatCL(value));
  }, [value]);

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    setDisplay(formatCL(raw));
    // send raw numeric string so it matches `{{nm}}` / `{nm }` helpers expectation
    onChange(raw);
  };

  return (
    <label className="label_gestdoc">
      <div style={{ display: "inline-flex" }}>
        {label} {required && <span style={{ fontSize: 13 }}>*</span>}
      </div>
      <input
        id={id}
        type="text"
        inputMode="numeric"
        className="input_gestdoc"
        placeholder={placeholder || "Ej: 1.500.000"}
        value={display}
        onChange={handleChange}
        required={required}
      />
    </label>
  );
};

export default NumberInput;
